import * as Sentry from '@sentry/react'

import { ErrorFallback } from './error-fallback'

interface Props {
  children: React.ReactNode
}

const handleError = (error: unknown, info: string) => {
  console.error(error, info)
  window.clarity?.('set', 'HasError', 'YES')

  const err = error as Error | undefined
  if (err && /Loading chunk \d+ failed/.test(err.message)) {
    window.location.reload()
  }
}

export function ErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} onError={handleError}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
